module.exports = __webpack_public_path__ + "img/blameZyhou.be4d93c9.jpeg";